module.exports = __webpack_public_path__ + "img/model_21_ug.39a70ca9.jpg";